export const earn = {
  jdzb: "Kiếm xu dễ dàng",
  jryd: "Tài chính là khôn ngoan và chúng ta có thể cùng nhau tiến bộ",
  jrbk: "Tham gia Biking để dễ dàng kiếm xu, với sự đổi mới không giới hạn nhằm tối đa hóa lợi ích từ tài sản kỹ thuật số của bạn",
  zbz: "Kiếm xu",
  ljsy: "Thu nhập tích lũy",
  zrsy: "Thu nhập của ngày hôm qua",
  hq: "Hiện tại",
  cknh: "Tham khảo hàng năm",
  sqjd: "Tiến trình đăng ký",
  sg: "Đăng ký",
  qbcp: "Tất cả sản phẩm",
  cz: "Cài lại",
  qx: "Thuật ngữ",
  question1: "1. Kiếm tiền là gì?",
  question1_text:
    "Kiếm xu là nền tảng dịch vụ một cửa do BIKING tạo ra nhằm giúp người dùng khám phá cơ hội cho nhiều loại sản phẩm nắm giữ tiền tệ. Hiện tại, cách kiếm xu đơn giản là Yubibao (gửi và rút bất cứ lúc nào), và sẽ có nhiều sản phẩm hơn nữa được ra mắt trong tương lai để cung cấp cho người dùng Cung cấp nhiều lựa chọn sản phẩm.",
  question2: "2. Tham chiếu hàng năm là gì?",
  question2_text:
    "Thu nhập từ việc kiếm token hiện là tiền lãi của các token được gửi. Việc tính hàng năm tham chiếu là việc tính lãi hàng năm đối với các token được ký gửi. Ví dụ: 1.000U đầu tiên của sản phẩm dựa trên mức tính hàng năm tham chiếu là 12% và 1.000U đầu tiên vượt quá 1.000U đầu tiên dựa trên mức tính hàng năm tham chiếu của. 2% Tổng lãi suất tham chiếu hàng năm là 14%.",
  question3: "3. Khi nào việc tích lũy/thanh toán lãi bắt đầu?",
  question3_text:
    "Khi đăng ký các sản phẩm khác nhau, thời gian tích lũy/thanh toán lãi có thể khác nhau. Lấy USDT kiếm tiền đơn giản dựa trên lãi suất hàng ngày hiện tại làm ví dụ, tiền lãi sẽ tích lũy vào lúc 2 giờ sáng (UTC+8) vào ngày hôm sau sau khi mua các sản phẩm hiện tại bằng USDT. Tại 5 giờ sáng (UTC+8) tại thời điểm T+1 (tức là thời gian mua T+2), tiền lãi của ngày trước ngày thanh toán vào ngày hôm sau sẽ được phát hành;",
  question4: "4. Khoản đầu tư còn lại là bao nhiêu?",
  question4_text:
    "Số tiền đầu tư còn lại là số tiền của sản phẩm tài chính bạn vẫn có thể đăng ký<br/>Số tiền đầu tư còn lại = tổng số tiền mua sản phẩm - số tiền bạn đã đăng ký",
  xzmbfs: "Chọn phương thức gửi/mua",
  nhsyl: "Tỷ suất lợi nhuận hàng năm và kỳ hạn:",
  sl: "Số lượng",
  qitou: "Bắt đầu đầu tư",
  max: "Tối đa",
  kzcsl: "Đây là số tiền có thể được chuyển ra khỏi tài khoản vốn",
  sykt: "Số tiền còn lại có thể đầu tư",
  syktsl: "Số tiền đầu tư còn lại là số tiền bạn vẫn có thể đăng ký",
  syktsx:
    "Số tiền đầu tư còn lại = tổng số tiền mua sản phẩm - số lượng bạn đã đăng ký (không lớn hơn giới hạn đầu tư riêng lẻ {amount}{coin})",
  jlgz: "Quy tắc khen thưởng",
  jd1: "Thang 1: {amount}{coin} đầu tiên",
  ptjl: "Phần thưởng nền tảng",
  jd2: "Thang 2: Lớn hơn {amount}{coin} đầu tiên",
  jd22:"Thang ",
  jd3: "Thang 3: Lớn hơn {amount}{coin} đầu tiên",
  grsgsx: "Giới hạn trên của đăng ký cá nhân là {amount}{coin}",
  gz: "Luật lệ",
  sgsj: "Thời gian đăng ký",
  xianzai: "Bây giờ",
  qxsj: "Thời gian bắt đầu quan tâm",
  lxrz: "Sở thích được ghi lại",
  c2c: "C2C mua xu",
  lhxz: "Lựa chọn linh hoạt, giá tốt hơn",
  lcjd: "Quy trình đơn giản, giao dịch nhanh chóng",
  crszhb: "Gửi tiền kỹ thuật số từ ví hoặc sàn giao dịch",
  zcsl: "Số lượng tài sản",
  dzsy: "Doanh thu nhận được",
  lcxx: "Thông tin quản lý tài chính",
  zt: "Trạng thái",
  sh: "Chuộc lỗi",
  sgje: "Số tiền đăng ký",
  sgzj: "{amount}{coin} đầu tiên của quỹ đăng ký có thể kiếm được {value}% tiền thưởng hàng năm",
  dyklqje:
    "Bất kỳ ai lớn hơn {amount}{coin} đều có thể kiếm được phần thưởng hàng năm là {value}%",
  grsged: "Số tiền đăng ký cá nhân là {amount}～{amoun2}{coin}",
  shsl: "Số lượng quy đổi",
  srshsl: "Nhập số tiền quy đổi",
  ksh: "Có thể đổi được:",
  haode: "ĐƯỢC RỒI",
  zcsg: "Đăng ký lại",
  sjdzsl: "Số lượng thực tế nhận được",
  shsj: "Thời gian quy đổi",
  jssj: "Thời gian giải quyết",
  sgcg: "Đăng ký thành công",
  shcg: "Quy đổi thành công",
  dq: "Thường xuyên",
  yjsdd: "Đã giải quyết đơn hàng",
  jyjl: "Bản ghi giao dịch",
  hqjdzb: "Kiếm tiền dễ dàng với tiền gửi hiện tại",
  sy: "lợi nhuận",
  wwc: "Chưa hoàn thành",
  xmlx: "loại dự án",
  hqjdzbcp: "Kiếm tiền dễ dàng với tiền gửi hiện tại. Đây là sản phẩm tài chính an toàn do Biking tạo ra. Nó hỗ trợ gửi và rút tiền 24 giờ một ngày và tiền lãi được tính theo giờ.",
  nh: "Hàng năm",
  zhzchz: "Chuyển tài sản tài khoản, đơn giản và nhanh chóng",
  qsrsl: "Xin vui lòng nhập số lượng",
  yjssymx: "Chi tiết thu nhập đã thanh toán",
  mx: "Chi tiết",
  qwsmrz: "Đi đến xác thực tên thật",
  jxwcsmrz: "1. Hoạt động này chỉ dành cho người dùng đã hoàn tất xác thực tên thật. Mỗi người dùng chỉ có một cơ hội tham gia hoạt động này",
  dqcked: "2. Số tiền gửi cố định của mỗi người dùng là {min}~{max}{coin} và hệ thống sẽ tự động quy đổi số tiền đó vào tài khoản khi đến hạn",
  cpbntjsh: "3. Sản phẩm này không thể được đổi trước",
  anzh: "4. Sau khi sản phẩm được đăng ký, tổng số tiền là 0 và nút chuyển sang màu xám",
  smrzyh: "Hoạt động này chỉ khả dụng với những người dùng đã hoàn tất xác thực tên thật,",
  jxcjyc: "Mỗi người dùng đủ điều kiện chỉ được tham gia một lần",
  ygsy: "Doanh thu ước tính",
  scqx: "Khoảng thời gian khóa",
  qixian: "{min}th day (tổng {max} days)",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/earn/vi.js